import { roles } from 'common/constants';
import _ from 'lodash';

export default function isWarehouse(rootStore) {
	return (
		_.findIndex(
			rootStore.app.baasic.userHandler.user.user.roles,
			role => role === roles.warehouseAccountOwner || role === roles.warehouseAdministrator || role === roles.warehouseUser
		) != -1
	);
}



// WEBPACK FOOTER //
// ./src/core/utils/isWarehouse.js